import React from 'react'
import AnimatedPage from '../../components/Animation/AnimatedPage'

export default function BannerImage() {
    return (
   
        <div className="md:w-1/2 w-full bg-[#EEF7FE]">
            <div className="w-full md:h-screen flex items-center justify-center">
                <AnimatedPage>
                    <img 
                        src="/images/login-pageImg.svg"
                        alt="loginPage-Img"
                        loading="lazy"
                        className="m-auto md:w-[500px] w-[197px]"
                        style={{height: "-webkit-fill-available"}} />
                </AnimatedPage>

            </div>
        </div>
    )
}
